import { Avatar, Box, Typography } from "@mui/material";
import React from "react";

const EmployeeList = ({ avatar, name, position, sx, sxAvatar, sxContent, ...rest }) => {
  return (
    <Box display="flex" alignItems="center" sx={{ ...sx }} {...rest}>
      <Avatar
        sx={{
          width: "45px",
          height: "45px",
          mr: 2,
          ...sxAvatar
        }}
        src={avatar}
      >
        {/* {`${name.split(' ')[0][0]}${name.split(' ')[1][0]}`} */}
      </Avatar>
      <Box display="flex" flexDirection="column" justifyContent="space-around">
        <Typography
          sx={{ ...sxContent }}
        >{name}</Typography>
        <Typography variant="body2" color="light-gray-text.main">
          {position}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmployeeList;
